import { useEffect, useState, useRef } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { api } from "../lib/api";
import { useContent } from "../lib/content";

export default function Exito() {
  const { t } = useContent();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const sessionId = params.get("session_id");
  const orderId = params.get("order_id");
  const [status, setStatus] = useState(t("exito_processing", "Verificando tu pago…"));
  const [attempts, setAttempts] = useState(0);
  const polling = useRef(false);

  useEffect(() => {
    if (!sessionId || polling.current) return;
    polling.current = true;
    const poll = async (n = 0) => {
      if (n >= 12) {
        setStatus("Tomó más de lo esperado. Revisa tu correo en unos minutos.");
        return;
      }
      try {
        const { data } = await api.get(`/checkout/status/${sessionId}`);
        setAttempts(n + 1);
        if (data.payment_status === "paid") {
          setStatus(t("exito_paid", "Pago confirmado ✦"));
          setTimeout(() => navigate(`/lectura/${data.order_id || orderId}`), 1500);
          return;
        }
        if (data.status === "expired") {
          setStatus("La sesión de pago expiró.");
          return;
        }
        setTimeout(() => poll(n + 1), 2000);
      } catch {
        setTimeout(() => poll(n + 1), 2500);
      }
    };
    poll(0);
  }, [sessionId, orderId, navigate, t]);

  return (
    <div data-testid="exito-page" className="min-h-screen">
      <Navbar />
      <section className="pt-40 pb-24 max-w-2xl mx-auto px-6 text-center">
        <div className="text-[#C9A25E] text-5xl mb-6 animate-pulse">✦</div>
        <p className="overline mb-3">{t("exito_overline")}</p>
        <h1 className="font-display text-5xl text-white font-light tracking-tighter mb-6">{status}</h1>
        {sessionId && <p className="text-zinc-500 text-sm">Intento {attempts}/12</p>}
      </section>
      <Footer />
    </div>
  );
}
